import { AfterViewInit, Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { StatisticsByMonth } from '@classes/client-statistics/client-statistics-by-month';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-crm-table-by-month',
  templateUrl: './crm-table-by-month.component.html',
  styleUrls: ['./crm-table-by-month.component.scss']
})
export class CRMTableByMonthComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() statistics: StatisticsByMonth[] = [];

  public dataSource: MatTableDataSource<StatisticsByMonth>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public displayedColumns = [
    "month",
    "numberOfOrders",
    "numberOfExtraOrders",
    "price",
    "extraPrice",
    "totalPrice",
  ];

  constructor() { }

  public ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.statistics);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  public ngOnChanges(): void {
    if (this.dataSource)
      this.dataSource.data = this.statistics;
  }

  public onExportExcel(): void {
    const rows = this._generateRowsForExcel();

    const worksheet = XLSX.utils.json_to_sheet(rows);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, worksheet, 'Feuille1');

    XLSX.writeFile(wb, 'recapitulatif-par-mois.xlsx');
  }

  private _generateRowsForExcel(): any[] {
    return this.dataSource.filteredData.map(row => ({
      Mois: row.month,
      Nbr_courses: row.numberOfOrders,
      Nbr_extra_courses: row.numberOfExtraOrders,
      Prix_mensuel: row.price,
      Prix_extra_courses: row.extraPrice,
      Prix_total: row.totalPrice,
    }));
  }
}
